import DOMPurify from 'dompurify';

// Allow list is limited to the markup the rich text editor can produce, plus
// the legacy markup found in already stored content (headings, nested lists).
// Everything else is dropped while its text content is kept.
const ALLOWED_TAGS = [
  'a',
  'b',
  'blockquote',
  'br',
  'code',
  'div',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'img',
  'li',
  'ol',
  'p',
  'pre',
  's',
  'span',
  'strike',
  'strong',
  'sub',
  'sup',
  'u',
  'ul',
];

const ALLOWED_ATTR = [
  'alt',
  'class',
  'height',
  'href',
  'rel',
  'src',
  'style',
  'target',
  'title',
  'width',
];

/**
 * Removes scripts, event handlers and any other executable markup from an HTML
 * string. Must be applied to every rich text value coming from the API before
 * it reaches the DOM, because rendering it goes through Quill, which assigns
 * the string to `innerHTML`.
 */
export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
